import React from "react";
import { Link } from "react-router-dom";

export default function Pagination({ links, onPageChange }) {

    const last_link = links.length - 1;

    const style = {
        color: "#024f6e",
    };

    return (
        <>
            <ul className="pagination">
                {links[0]?.url !== null ? (
                    <li className="page-item">
                        <Link
                            className="page-link"
                            to={'?page='+links[0]?.label}
                            style={style}
                        >
                            &laquo;
                        </Link>
                    </li>
                ) : (
                    <li className="page-item">
                        <Link className="page-link disabled" href="#">
                            &laquo;
                        </Link>
                    </li>
                )}
                {links.map((link, index) =>
                    index >= 1 && index < last_link ? (
                        <li
                            key={link.label}
                            className={`page-item ${
                                link.active === true ? "active" : ""
                            }`}
                        >
                            <Link onClick={() => onPageChange(link.label)} className={`page-link`} to={'?page='+link.label}>
                                {link.label}
                            </Link>
                        </li>
                    ) : (
                        ""
                    )
                )}
                {links[last_link]?.url !== null ? (
                    <li className="page-item">
                        <Link
                            className="page-link"
                            to={'?page='+links[last_link]?.label}
                            style={style}
                        >
                            &raquo;
                        </Link>
                    </li>
                ) : (
                    <li className="page-item">
                        <Link className="page-link disabled" href="#">
                            &raquo;
                        </Link>
                    </li>
                )}
            </ul>
        </>
    );
}